export default "__VITE_ASSET__0fa148df__"